webpackJsonp([195916667118452],{

/***/ 1186:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0003_timely_messenger.jpg","type":"Unit","subtype":"Mercenary","cost":1,"ATK":1,"HP":1,"rules_text_1":"Haste (Can attack and play ⤵ abilities, if he had any, the turn he arrives.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Timely Messenger","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"\"I'm never late.\"","color":"Neutral","spec":null,"bottom":"Tech 0","rulings":[],"keywords":["Haste"],"slug":"timely_messenger"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"timely_messenger","keywords":["Haste"],"imageRegex":"/timely_messenger.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-timely-messenger-705720dd3cda71817dce.js